/**
 * 黑白（M4-补充 / 对比 Photoshop 补全第一档缺口 阶段 1）。
 *
 * 真实 Photoshop 按六个色相区间（红/黄/绿/青/蓝/洋红）各给一个权重，
 * 需要先把像素转到色相角再插值——这次只做三通道版（R/G/B 权重各自
 * 可调，默认 40/40/20，加权求和后夹到 0–255），不做完整的六色相面板，
 * 在完成报告里说明这个简化。
 */
export interface BlackAndWhiteParams {
  /** 红色权重，百分之几（0–300）。 */
  readonly r: number;
  /** 绿色权重，百分之几（0–300）。 */
  readonly g: number;
  /** 蓝色权重，百分之几（0–300）。 */
  readonly b: number;
}

export const DEFAULT_BLACK_AND_WHITE_PARAMS: BlackAndWhiteParams = { r: 40, g: 40, b: 20 };

export function applyBlackAndWhite(
  r: number,
  g: number,
  b: number,
  params: BlackAndWhiteParams,
): [number, number, number] {
  const gray = Math.round(
    Math.min(255, Math.max(0, (r * params.r + g * params.g + b * params.b) / 100)),
  );
  return [gray, gray, gray];
}
